import React, { useState, useEffect } from "react";
import { Table, Button, message, Drawer, Row, Col, Modal, Spin } from "antd";
import { manageWorkflowMetaData } from '../../../services/admin/adminService';
import LoadDataGroup from "../components/LoadDataGroup";
import '../assets/styles/common.css';
import Grid from "../components/CommonFields/Grid";

const WorkflowMetaData = ({ wfId }) => {
    const [showDrawer, setShowDrawer] = useState(false);
    const [workflowMetaGroup, setworkflowMetaGroup] = useState([]);
    const [selectedGroupRows, setSelectedGroupRows] = useState([]);
    const [loading, setLoading] = useState(false);

    // Define parent columns
    const parentColumns = [
        { title: "Group Name", dataIndex: "groupName", key: "groupName" },
    ];

    // Child columns
    const getChildColumns = () => {
        return [
            { title: "Field Name", dataIndex: "Name", key: "Name" },
            { title: "Data Type", dataIndex: "DataType", key: "DataType" },
            { title: "Secured", dataIndex: "IsSecured", key: "IsSecured", hidden: true },
            { title: "Index", dataIndex: "Index", key: "Index", tag: true, tagColor: "#0e8617" },
            { title: "Unique", dataIndex: "Unique", key: "Unique", tag: true, tagColor: "#0e8617", boolean: true },
            { title: "Hash Required", dataIndex: "HashRequired", key: "HashRequired" },
            { title: "Hash Positions", dataIndex: "HashPositions", key: "HashPositions", hidden: true },
            { title: "Default Value", dataIndex: "Value", key: "Value" },
        ];
    };

    // Handler to receive selected IDs from child
    const handleSave = (selectedIds) => {
        attachMetaDataGroupToWorkflow(selectedIds);
    };

    //Load metadata groups for the workflow if exists
    const fetchmetaDataGroupsForFlow = async () => {
        setLoading(true);
        const flowId = wfId;
        const dataGroupId = '[]';
        const action = "get";
        const response = await manageWorkflowMetaData(flowId, dataGroupId, action);
        //console.log("Get:", response);
        if (response?.data.success) {
            if (response?.data?.data?.metaData?.length > 0) {
                console.log("metaData:", response?.data?.data?.metaData);
                setworkflowMetaGroup(response?.data?.data?.metaData);
            }
            else {
                setworkflowMetaGroup([]);
            }
        }
        else {
            console.log("Error in fetching workflow metadata:", response?.data?.businessRules[0]);
            message.error(response?.data?.businessRules[0]);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchmetaDataGroupsForFlow();
    }, [wfId]);

    // Attach data group to workflow from selected groups
    const attachMetaDataGroupToWorkflow = async (selectedGroupIds) => {
        const flowId = wfId;
        const action = "attach";
        if (selectedGroupIds.length > 0) {
            const response = await manageWorkflowMetaData(flowId, JSON.stringify(selectedGroupIds), action);
            //console.log("attach:", response);
            if (response?.data?.success) {
                fetchmetaDataGroupsForFlow();
                message.success("Data group attached successfully");
                setShowDrawer(false);
            }
            else {
                let err = response?.data?.businessRules?.[0] || 'Unknown error';
                let fieldsJson = {};
                try {
                    fieldsJson = JSON.parse(response?.data?.data || '{}');
                } catch (e) {
                    console.error('Invalid JSON in data field');
                }
                const details = Object.entries(fieldsJson).map(([key, val]) => {
                    let items = [];
                    try { items = JSON.parse(val); } catch { }
                    return (<div key={key}><strong>{key}:</strong> {Array.isArray(items) ? items.join(', ') : val}</div>);
                });
                message.error(<div><div>{err}</div>{details}</div>);
            }
        } else {
            message.error("Please select atleast one data group to attach");
        }
    };

    //Detach data group from workflow
    const detachMetaDataGroupFromWorkflow = async () => {
        const getSelectedGroupIds = selectedGroupRows;
        if (getSelectedGroupIds?.length === 0) { message.error("Please select atleast one Group"); return; }
        if (getSelectedGroupIds?.length > 0) {
            Modal.confirm({
                title: 'Are you sure to detach the selected Group(s)?',
                //content: 'This will detach the data group from the workflow.',
                okText: 'Yes',
                cancelText: 'No',
                async onOk() {
                    const flowId = wfId;
                    const dataGroupId = getSelectedGroupIds;
                    const action = "detach";
                    const response = await manageWorkflowMetaData(flowId, JSON.stringify(dataGroupId), action);
                    //console.log("detach", response);
                    if (response?.data.success) {
                        message.success("Data group detached successfully");
                        fetchmetaDataGroupsForFlow();
                    }
                    else {
                        console.log("Error in fetching workflow metadata:", response?.data?.businessRules[0]);
                        message.error("Detach process is failed");
                    }
                }
            });
        }
    };

    // Expandable row render function
    const expandedRowRender = (record) => {
        const childColumns = getChildColumns(record?.groupConfig);
        const childData = JSON.parse(record?.groupConfig).Fields.map((field, index) => ({
            key: index,
            ...field,
        }));

        return (
            // <Table
            //     columns={childColumns}
            //     dataSource={childData}
            //     pagination={false}
            // />
            <Grid
                columnData={{ columns: childColumns }}
                tableData={childData}
                // rowKey="metaDataId"
                searchButton={false}
                downloadCSV={false}
                showEdit={false}
                showDelete={false}
                showView={false}
                showPagination={false}
                // csvFileName="StepData"
                // paginationConfig={{ pageSizeOptions: ['10', '20', '50', '100'] }}
                //className="custom-grid"
                createButton={false}
                enableRowSelection={false}
                // expandableRowRender={expandedRowRender}
                // onRowSelectionChange={handleRowSelection}
                locale={{ emptyText: 'No data found' }}
            />
        );
    };

    const handleRowSelection = (selectedKeys, selectedRows) => {
        setSelectedGroupRows(selectedKeys);
    };

    return (
        <>
            <Row style={{ marginBottom: "10px" }}>
                <Col span={12}>
                    <h2 style={{ margin: "0" }}>Client data Groups</h2></Col>
                <Col span={12} style={{ textAlign: "right" }}>
                    <div>
                        {/* <small>  {workflowMetaGroup.length == 0 && (<>No <b>Data Group</b> is attached.</>)} Click here to</small> */}
                        <Button type="primary" onClick={() => setShowDrawer(true)}>Attach</Button>

                        {workflowMetaGroup.length > 0 && (
                            <>
                                {/* <small>Click here to</small> */}
                                <Button style={{ marginLeft: "10px" }} type="primary" onClick={() => detachMetaDataGroupFromWorkflow()}>Detach</Button>
                            </>
                        )}

                    </div></Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div>
                        {showDrawer && (
                            <Drawer
                                title="Attach data group"
                                placement="right"
                                onClose={() => setShowDrawer(false)}
                                open={showDrawer}
                                width={400}
                                className="custom-drawers cus-drawer-sm"
                            >
                                <LoadDataGroup onSave={handleSave} />
                            </Drawer>
                        )}

                        {/* <Table
                    columns={parentColumns}
                    dataSource={workflowMetaGroup}
                    rowKey="metaDataId"
                    expandable={{ expandedRowRender }}
                    pagination={false}
                /> */}
                        <Spin spinning={loading}>
                            <Grid
                                columnData={{ columns: parentColumns }}
                                tableData={workflowMetaGroup}
                                rowKey="metaDataId"
                                searchButton={true}
                                downloadCSV={true}
                                showEdit={false}
                                showDelete={false}
                                showView={true}
                                csvFileName="StepData"
                                paginationConfig={{ pageSizeOptions: ['10', '20', '50', '100'] }}
                                className="custom-grid"
                                createButton={false}
                                enableRowSelection={true}
                                expandableRowRender={expandedRowRender}
                                onRowSelectionChange={handleRowSelection}
                                locale={{ emptyText: 'No data found' }}
                            />
                        </Spin>

                    </div>
                </Col>
            </Row>

        </>
    );
};

export default WorkflowMetaData;